import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { toast } from 'react-toastify';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { dataService } from '../../Services/data.service';
import { makeStyles } from '@material-ui/core';

export default function BuyingUnits(props) {

  const [uoms, setUoms] = useState([])
  const [uom, setUom] = useState(null)
  const classes = useStyles();

  useEffect(() => {
    dataService.getUoms().then(units => {

      if (JSON.stringify(uoms) !== JSON.stringify(units.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))) {
        setUoms(units.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))
      }

      console.log(props.chosenValue)
      if (props.chosenValue) {
        if (JSON.stringify(uom) !== JSON.stringify(units.Results.find(x => x.Name === props.chosenValue))) {
          setUom(units.Results.find(x => x.Name === props.chosenValue))
        }
      }
     
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
  }, [])

  const setNextStep = () => {
    validate();
  }

  const validate = () => {
    if (uom) {
      props.SetNext();
      props.setContent(uom.ID, uom.Name);
      props.setDetailUOM(uom.ID);
    } else {
      toast.error("Pick a buying unit", { position: toast.POSITION.TOP_CENTER })
    }
  }

  const onChangeItem = (e) => {
    setUom(uoms.find(x => x.ID === e.target.value))
    console.log(uoms.find(x => x.ID === e.target.value))
  }

  return (
    <div className={classes.uomContainer}>
      <React.Fragment>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select2"
          className={classes.uomPicker}
          value={uom && uom.ID}
          onChange={(e) => onChangeItem(e)}
        >
          {uoms.map(x => {
            return (
              <MenuItem value={x.ID}>{x.Name}</MenuItem>)
          })}

        </Select>
        <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
      </React.Fragment> 
    </div>
  )
}


const useStyles = makeStyles({
  uomContainer: {
    marginTop: "30px"
  },
  buttonContainer: {
    width: "15%",
    flex: 1,
    justifyContent: 'center'
  },
  uomPicker:{
    height: 44,
    backgroundColor: 'white',
    borderWidth: 1,
    marginBottom: 10,
    width: "100%"
  }
});